import type { WarningsInterface } from 'store/simulation/types';

export const CHAMBER_ANALYSIS = 'CHAMBER_ANALYSIS';
export const CHAMBER_ANALYSIS_RESULT = 'CHAMBER_ANALYSIS_RESULT';

export interface ChamberUnitInfoInterface {
  modelName: string;
  mantle: string;
  concave: string;
  unitThrow: number;
  css: number;
}

export interface CoordinateInterface {
  x: number;
  y: number;
}

export interface FeedSizeInterface {
  origin: CoordinateInterface;
  radius: number;
  y: number;
}

export interface CompressionZoneInterface {
  concave: CoordinateInterface;
  mantleOSS: CoordinateInterface;
  compRatio?: number;
}

export interface ChamberGeometryInterface {
  concave: CoordinateInterface[];
  mantleNominal: CoordinateInterface[];
  mantleOpen: CoordinateInterface[];
  mantleClosed: CoordinateInterface[];
  mantleSecondaryProfile: CoordinateInterface[];
  feedSize: FeedSizeInterface[];
  compressionZones: CompressionZoneInterface[];
}

export interface ChamberAnalysisInterface {
  unitInfo: ChamberUnitInfoInterface;
  fillerRing: string;
  chamberMatch: number;
  oilUnderHP: number;
  minOilBlwHP: number;
  nomCalcCapacity: number;
  geometry: ChamberGeometryInterface;
  warnings: WarningsInterface;
}

export interface ChamberUnitRequestInterface {
  key: string;
  unitInfo: ChamberUnitInfoInterface;
}

export interface ChamberAnalysisRequestInterface {
  units: ChamberUnitRequestInterface[];
}

export interface ChamberUnitResponseInterface {
  key: string;
  analysis?: ChamberAnalysisInterface | null;
  error?: string | null;
}

export interface ChamberAnalysisResponseInterface {
  units: ChamberUnitResponseInterface[];
}
